const NotificationTypes = Object.freeze({
  Success: 'Success',
  Warning: 'Warning',
  Error: 'Error',
  Fatal: 'Fatal',
  Info: 'Info'
})

export { NotificationTypes }